import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";

export interface SubscribeToNotificationsPayload {
    email: string;
    phone?: string;
    general_marketing_consent: boolean;
    phone_marketing_consent: boolean;
    email_marketing_consent: boolean;
    search_data?: Record<string, unknown>;
}

export const subscribeToNotificationsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        subscribeToNotifications: builder.mutation<void, SubscribeToNotificationsPayload>({
            query: (body) => ({
                url: apiLink.user.notifications({})(null),
                method: "POST",
                body
            })
        })
    })
});

export const {useSubscribeToNotificationsMutation} = subscribeToNotificationsApi;
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";

export interface SubscribeToNotificationsPayload {
    email: string;
    phone?: string;
    general_marketing_consent: boolean;
    phone_marketing_consent: boolean;
    email_marketing_consent: boolean;
    search_data?: Record<string, unknown>;
}

export const subscribeToNotificationsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        subscribeToNotifications: builder.mutation<void, SubscribeToNotificationsPayload>({
            query: (body) => ({
                url: apiLink.user.notifications({})(null),
                method: "POST",
                body
            })
        })
    })
});

export const {useSubscribeToNotificationsMutation} = subscribeToNotificationsApi;
